import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpService } from 'src/app/http.service';
import { SnackbarService } from 'src/app/snackbar.service';
import { Messages } from '../../constants/messages';

@Component({
  selector: 'app-delete-bill-modal',
  templateUrl: './delete-bill-modal.component.html',
  styleUrls: ['./delete-bill-modal.component.scss']
})
export class DeleteBillModalComponent implements OnInit {
  reason;

  messages = new Messages();
  constructor(private dialog: MatDialogRef<DeleteBillModalComponent>, @Inject(MAT_DIALOG_DATA) private parentData: any, private http: HttpService, private snackbar: SnackbarService) { }

  ngOnInit() {
    console.log(this.parentData);
  }

  deleteBill(){
    let valid = true;
    if(!this.reason){
      valid= false;
      this.snackbar.openSnackBar(this.messages.DELETE_BILL.VALIDATION.REASON_EMPTY,'','err');
    }

    if(valid){
      let payload = {
        id:this.parentData.id,
        delete_reason:this.reason
      }

      this.http.post('carrier_bill/delete',payload,1).subscribe(
        (data:any)=>{
          if(data.statusCode == 200){
            this.snackbar.openSnackBar(this.messages.DELETE_BILL.SUCCESS.DELETE);
            this.dialog.close(data);
          }
        },
        (err: any) => {
          this.snackbar.openSnackBar(err.error.message,'','err');
        }
      )
      
    }
  }

  close(){
    this.dialog.close();
  }

}
